import React, { useContext } from "react";
import {
  faShieldHalved,
  faUsersCog,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getRuta, isAccess } from "../../helpers/Helpers";
import { DataContext } from "../../context/DataContext";
import { GrupoNav, ItemNav } from "./ItemNav";

const Security = ({ drawerIsOpen }) => {
  const { access } = useContext(DataContext);
  let rout = getRuta();
  return isAccess(access, "SECURITY VER") ? (
    <GrupoNav
      icono={<FontAwesomeIcon icon={faShieldHalved} fixedWidth />}
      texto="Seguridad"
      drawerIsOpen={drawerIsOpen}
    >
      <ItemNav
        to={`${rout}/users`}
        icono={<FontAwesomeIcon icon={faUsersCog} fixedWidth />}
        texto="Usuarios"
        drawerIsOpen={drawerIsOpen}
      />

      <ItemNav
        to={`${rout}/rols`}
        icono={<FontAwesomeIcon icon={faUserShield} fixedWidth />}
        texto="Roles"
        drawerIsOpen={drawerIsOpen}
      />
    </GrupoNav>
  ) : (
    <></>
  );
};

export default Security;
